import { hasObrasFilters } from "@/modules/obras";
import type { ObrasEmptyProps, ObrasEmptyViewModel } from "./types-obras-empty";

export function useObrasEmpty({
  search,
  filters,
  onClearSearch,
  onClearFilters,
}: ObrasEmptyProps): ObrasEmptyViewModel {
  const hasSearch = search.trim() !== "";
  const hasFilters = hasObrasFilters(filters);

  return {
    hasSearch,
    hasFilters,
    onClear: hasSearch ? onClearSearch : hasFilters ? onClearFilters : undefined,
  };
}
